// Copyright (c) 2025 Goffy. All Rights Reserved.

import { create } from 'zustand';

type RoundState = {
  roundId: string | null;
  hole: number | null;
  scorerOnlyMode: boolean;
  scorerPlayerId: string | null;
  holeMenuRequestVersion: number;
  setRoundId: (roundId: string | null) => void;
  setHole: (hole: number | null) => void;
  setRoundAndHole: (roundId: string | null, hole: number | null) => void;
  setScorerOnlyMode: (enabled: boolean) => void;
  setScorerPlayerId: (playerId: string | null) => void;
  requestHoleMenuOpen: () => void;
  clearHoleMenuRequest: () => void;
  clear: () => void;
};

export const useRoundState = create<RoundState>((set) => ({
  roundId: null,
  hole: null,
  scorerOnlyMode: false,
  scorerPlayerId: null,
  holeMenuRequestVersion: 0,
  setRoundId: (roundId) => set({ roundId }),
  setHole: (hole) => set({ hole }),
  setRoundAndHole: (roundId, hole) => set({ roundId, hole }),
  setScorerOnlyMode: (enabled) => set({ scorerOnlyMode: enabled }),
  setScorerPlayerId: (playerId) => set({ scorerPlayerId: playerId }),
  requestHoleMenuOpen: () =>
    set((state) => ({ holeMenuRequestVersion: state.holeMenuRequestVersion + 1 })),
  clearHoleMenuRequest: () => set({ holeMenuRequestVersion: 0 }),
  clear: () => set({ roundId: null, hole: null, scorerOnlyMode: false, scorerPlayerId: null, holeMenuRequestVersion: 0 }),
}));
